import {formatMidasNumber, convertDateFormat} from "../../global";
import MoreOptions from "@mui/icons-material/MoreVert";
import {Link} from "react-router-dom";
import {useState} from "react";
import { UXDataTableWithoutBody, StyledTableCell, UXDataTableNested, StyledTableBody, StyledTableRow } from "../../components/UXDataTable";
import {IconButton,TableRow, Menu, MenuItem} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const experimentCols = ['ID', 'Cuts', 'MIDAS # / Container', 'Mnemonic', 'Description', 'Requester Email', 'Requested Completion Date', 'Status']
const cutCols = ['MIDAS #', 'Chem ID', 'Type','Comments','Requsted Start Temp (C)', 'Requsted End Temp (C)', 'Actual Start Temp (C)', 'Actual End Temp (C)']

const SearchDistillations = ({inputSearchCriteria, myExperiments, dataIsLoading}) => {

  const [cutRowOpen, setCutRowOpen] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [anchorEl, setAnchorEl] = useState([]);

  const noDataMessage = `No distillation info found matching the quick search for = ${inputSearchCriteria}`

  const openMenu = (index) => {
    return anchorEl[index] != null
  }

  const handleClickMenu = (event, index) => {
    const newAnchorEl = [...anchorEl]

    newAnchorEl[index] = event.currentTarget

    setAnchorEl(newAnchorEl)
  }

  const handleCloseMenu = (e, reason, index) => {
    const newAnchorEl = [...anchorEl]

    newAnchorEl[index] = null

    setAnchorEl(newAnchorEl)
  }

  const isCompletedExperiment = (experiment) => experiment.distillationStatusName === 'Completed';

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCutsRowClick = (experimentID) => {
    const cutRowOpenIndex = cutRowOpen.indexOf(experimentID);
    let newCutRowOpen = [];

    if (cutRowOpenIndex === -1) {
      newCutRowOpen = newCutRowOpen.concat(cutRowOpen, experimentID);
    } else if (cutRowOpenIndex === 0) {
      newCutRowOpen = newCutRowOpen.concat(cutRowOpen.slice(1));
    } else if (cutRowOpenIndex === cutRowOpen.length - 1) {
      newCutRowOpen = newCutRowOpen.concat(cutRowOpen.slice(0, -1));
    } else if (cutRowOpenIndex > 0) {
      newCutRowOpen = newCutRowOpen.concat(
        cutRowOpen.slice(0, cutRowOpenIndex),
        cutRowOpen.slice(cutRowOpenIndex + 1)
      );
    }
    setCutRowOpen(newCutRowOpen);
  };

  const determineStartArray = () => {
    return (myExperiments.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage))
  }

  const getFirstNonEmptyValue = (...values) =>
    values.find((value) => {
      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      return value !== null && value !== undefined;
    });

  const getObjectSampleName = (obj) => {
    if (!obj || typeof obj !== "object") {
      return undefined;
    }

    const directSampleName = getFirstNonEmptyValue(
      obj.sampleName,
      obj.SampleName,
      obj?.sample?.sampleName,
      obj?.sample?.SampleName,
    );

    if (directSampleName) {
      return directSampleName;
    }

    const sampleNameKey = Object.keys(obj).find((key) => key.toLowerCase() === "samplename");
    return sampleNameKey ? obj[sampleNameKey] : undefined;
  };

  const findSampleNameDeep = (value, visited = new Set(), depth = 0, parentKey = "") => {
    if (depth > 5 || value === null || value === undefined) {
      return undefined;
    }

    if (typeof value === "string") {
      if (parentKey.toLowerCase().includes("samplename")) {
        return value.trim().length > 0 ? value : undefined;
      }

      return undefined;
    }

    if (typeof value !== "object") {
      return undefined;
    }

    if (visited.has(value)) {
      return undefined;
    }
    visited.add(value);

    const objectSampleName = getObjectSampleName(value);
    if (objectSampleName) {
      return objectSampleName;
    }

    const keys = Object.keys(value);
    for (const key of keys) {
      if (key.toLowerCase().includes("samplename")) {
        const sampleNameValue = getFirstNonEmptyValue(value[key]);
        if (sampleNameValue) {
          return sampleNameValue;
        }
      }
    }

    for (const key of keys) {
      const nestedValue = findSampleNameDeep(value[key], visited, depth + 1, key);
      if (nestedValue) {
        return nestedValue;
      }
    }

    return undefined;
  };

  const getInitialContainerSampleName = (experiment) =>
    getFirstNonEmptyValue(
      experiment?.initialContainer?.sample?.sampleName,
      experiment?.initialContainer?.sampleName,
      experiment?.initialContainer?.sample?.name,
      experiment?.initialContainer?.SampleName,
      experiment?.["initialContainer.sampleName"],
      experiment?.["initialContainer.sample.sampleName"],
    );

  const getCutSampleName = (cut, experiment) =>
    getFirstNonEmptyValue(
      cut?.thisContainer?.sampleName,
      cut?.sampleName,
      cut?.thisContainer?.sample?.sampleName,
      cut?.thisSample?.sampleName,
      cut?.thisSample?.sample?.sampleName,
      cut?.SampleName,
      cut?.["thisContainer.sampleName"],
      cut?.["thisSample.sampleName"],
      cut?.["thisContainer.sample.sampleName"],
      cut?.["sample.sampleName"],
      getObjectSampleName(cut?.thisContainer),
      getObjectSampleName(cut?.thisSample),
      findSampleNameDeep(cut),
      getInitialContainerSampleName(experiment),
    );

  const isCutRowOpen = (experimentID) => cutRowOpen.indexOf(experimentID) !== -1;
  return (
    <>
    <UXDataTableWithoutBody 
      tableWidth='100%' 
      cols={experimentCols} 
      blankFirstHeader={true}
      tableId="myWRTable"
      rowLength={myExperiments ? myExperiments.length : 0}
      enablePaging={true}
      rowsPerPage={rowsPerPage}
      page={page}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      noDataFoundMessage={noDataMessage}
      enableAddIcon={false}
      addFunction={null}
      addToolTipText={null}  
      isDataLoading={dataIsLoading}
      >

        {myExperiments && myExperiments.length > 0 ? (
          determineStartArray().map((experiment, index) => {
          
            return (
              <StyledTableBody key={"myExperimentTablebody" + index}> 
                <StyledTableRow>

                  <StyledTableCell component='th' scope='row' style={{width:'2rem'}}>
                    {isCompletedExperiment(experiment) && (
                      <>
                        <MoreOptions color='black' aria-haspopup="true" onClick={e => handleClickMenu(e, index)}/>
                        <Menu
                          key={`menu${index}`}
                          anchorEl={anchorEl[index]}
                          open={openMenu(index)}
                          onClose={(e, reason) => handleCloseMenu(e, reason, index)}
                        >
                          <MenuItem
                            key={`menuItem${index}`}
                            component={Link}
                            to={{ pathname: '/processDistillation', state: { incomingExperimentID: experiment.id } }}
                            disabled={false}
                          >{'View Experiment'}</MenuItem>
                        </Menu>
                      </>
                    )}
                  </StyledTableCell>

                  <StyledTableCell component='th' scope='row'>{experiment.id}</StyledTableCell>

                    <StyledTableCell align='right' style={{width:'5rem'}}>

                    {experiment.experimentCuts?.length ?? 0}

                      <IconButton
                        aria-label='expand row'
                        size='small'
                        onClick={() => handleCutsRowClick(experiment.id)}>
                        {isCutRowOpen(experiment.id) ? (
                          <KeyboardArrowUpIcon/>
                        ) : (
                          <KeyboardArrowDownIcon/>
                        )}
                      </IconButton>
                    </StyledTableCell>
                          
                    <StyledTableCell>
                      {experiment.initialContainer
                        ? `${formatMidasNumber(
                            getInitialContainerSampleName(experiment)
                          )}/${experiment.initialContainer.containerNumber}`
                        : ''}
                    </StyledTableCell>
                    <StyledTableCell>{experiment.mnemonic}</StyledTableCell>
                    <StyledTableCell>{experiment.experimentDescription}</StyledTableCell>
                    <StyledTableCell>{experiment.requestedByEmail}</StyledTableCell>
                    <StyledTableCell>{convertDateFormat(experiment.requestedCompletionDate, false)}</StyledTableCell>
                    <StyledTableCell>{experiment.distillationStatusName}</StyledTableCell>
                  </StyledTableRow>

                {isCutRowOpen(experiment.id) && (
                  <UXDataTableNested 
                  tableWidth={'100%'} 
                  cols={cutCols} 
                  blankFirstHeader={false} 
                  colSpan={experimentCols.length + 1} 
                  isOpenComparator={experiment.id} 
                  isOpenArray={cutRowOpen}>

                    {(experiment.experimentCuts ?? []).map((cuts) => {

                      return (
                    <StyledTableBody key={`${experiment.id}${cuts.id}_"cutstablebody"`}>
                      <StyledTableRow>
                        <StyledTableCell sx={{minWidth:"8rem"}}>
                          {formatMidasNumber(getCutSampleName(cuts, experiment))}
                        </StyledTableCell>
                        <StyledTableCell>{cuts.chemID}</StyledTableCell>
                        <StyledTableCell>{cuts.distillationCutTypeName}</StyledTableCell>
                        <StyledTableCell>{cuts.comments}</StyledTableCell>
                        <StyledTableCell>{cuts.requestedStartingTemperatureC}</StyledTableCell>
                        <StyledTableCell>{cuts.requestedEndTemperatureC}</StyledTableCell>
                        <StyledTableCell>{cuts.actualStartingTemperatureC === null ? '' : cuts.actualStartingTemperatureC}</StyledTableCell>
                        <StyledTableCell>{cuts.actualEndTemperatureC == null ? '' : cuts.actualEndTemperatureC}</StyledTableCell>
                      </StyledTableRow>
                      
                      </StyledTableBody>
                      )
                      })}
                      </UXDataTableNested>
                    )}
                
                </StyledTableBody>
            );
          })
        ) : (
          <StyledTableBody key={"no Distillations found"}>
            <TableRow key={"nothing found dist"}>
            <StyledTableCell colSpan='14' key={"nothing found cells dist"}>
              <p>{noDataMessage}</p>
            </StyledTableCell>
          </TableRow>
          </StyledTableBody>
        )}
  </UXDataTableWithoutBody>
  </>
  );
};

export default SearchDistillations;
